/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the auth module.
 */

export const MENU_TITLE = 'MENU_TITLE';
export const ROLES = 'ROLES';
export const MAIN_INFO = 'MAIN_INFO';
export const SHOW_SPINNER = 'SHOW_SPINNER'
export const DEFAULT_USER_STATUS = 'DEFAULT_USER_STATUS'
export default {
  MENU_TITLE,
  ROLES,
  MAIN_INFO,
  SHOW_SPINNER,
  DEFAULT_USER_STATUS,
};
